import styled from "styled-components"
import { device } from "breakpoints"
import { getGradient } from "../../utils/helpers/getGradient"
import { getSolidColor } from "../../utils/helpers/getSolidColor"
import { Button } from "components/Button"
import { Label } from "../Button/style"
import { Teaser } from "../Teaser"
import {
  Title,
  Excerpt,
  ImageWrapper,
  InfoWrapper,
  InnerLink,
} from "../Teaser/style"

export const RelatedPagesButton = styled(Button)`
  border: 0px;
  padding: 0;

  ${Label} {
    font-weight: 600;
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    border: none;
    transition: 200ms;

    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 30px;
    }

    :after {
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: 1;
      background: ${props => getSolidColor(props.theme.site)};

      @media ${device.desktop} {
        bottom: 0;
      }
    }
  }
`

export const RelatedPagesContainer = styled.div`
  padding-top: 35px;
  padding-bottom: 35px;
  background: #f6f8fa;
  @media ${device.desktop} {
    padding-top: 115px;
    padding-bottom: 115px;
  }
`

export const RelatedPagesTitle = styled.h5`
  font-weight: 700;
  font-size: 36px;
  color: #000000;
  letter-spacing: -0.38px;
  line-height: 36px;

  @media ${device.desktop} {
    font-size: 48px;
    letter-spacing: -0.5px;
    line-height: 42px;
  }
`

export const RelatedPagesTeaser = styled(Teaser)`
  :hover {
    ${RelatedPagesButton} {
      :after {
        display: none;
      }
    }
  }

  ${Title} {
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    letter-spacing: -0.21px;
    line-height: 24px;
    text-transform: capitalize;
    margin-bottom: 8px;

    @media ${device.desktop} {
      font-size: 28px;
      letter-spacing: -0.29px;
      line-height: 120%;
      margin-top: 4px;
      margin-bottom: 19px;
    }
  }

  ${InnerLink} {
    font-size: 16px;
    margin-top: 5px;
    @media ${device.desktop} {
      font-size: 20px;
    margin-top: 10px;

    }
  }
  ${Excerpt} {
    font-weight: 400;
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    margin-bottom: 7px;

    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 30px;
      margin-bottom: 10px;
    }
  }
  ${ImageWrapper} {
    padding-top: 72%;
    margin-bottom: 23px;
    @media ${device.desktop} {
      margin-bottom: 20px;
    }
  }
  ${InfoWrapper} {
    padding-right: 15px;
    @media ${device.desktop} {
      padding-right: 0;
    }
  }
  @media ${device.desktop} {
    :hover {
      cursor: pointer;
      ${Label} {
        :after {
          display: none;
        }
      }
      ${Title} {
        color: ${props => getSolidColor(props.theme.site)};
      }
    }
  }
`
